import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import styles from './LanguagePicker.module.scss';
import { getFallbackLanguage } from '../../i18n';

export const LanguagePicker = () => {
	const { i18n } = useTranslation();
	const selectedLanguage = getFallbackLanguage(i18n.language)

	const setLanguage = (lng: string) => {
		i18n.changeLanguage(lng);
	};

	return (
		<div className={styles.languageButtons}>
			<button
				type='button'
				onClick={() => setLanguage('en')}
				className={classNames(styles.flag, styles.en, {
					[styles.selected]: selectedLanguage === 'en'
				})}
			/>
			<button
				type='button'
				onClick={() => setLanguage('de')}
				className={classNames(styles.flag, styles.de, {
					[styles.selected]: selectedLanguage === 'de'
				})}
			/>
		</div>
	);
};
